export enum AuthStatus {
  LOGGED_OUT,
  PENDING,
  LOGGED_IN
}
